export default __webpack_public_path__ + "static/media/limb_main_mobile.1f3abb6a.jpg";